import { useCallback } from "react";
import "../../styles/layouts/infobar.scss";
import { SpaceModel, shouldHideSchedule, hasContacts, hasTech } from "../../interfaces/Space";
import InfoSchedule from "./InfoSchedule";
import InfoContacts from "./InfoContacts";
import Collapsible from "../Collapsible";
import InfoTech from "./InfoTech";
import InfoDescription from "./InfoDescription";
import InfoImages from "./InfoImages";
import CollapsibleContainer from "../CollapsibleContainer";
import InfoAddress from "./InfoAddress";
import { mapbp } from '../../properties'
import UseMapboxStaticImage from "../../hooks/UseMapboxStaticImage";

type Props = {
    space: SpaceModel | undefined,
    open: boolean
}

const shouldShowBio = process.env.REACT_APP_SHOW_BIO === 'true';

export default function InfoBar({ space, open }: Props) {


    const { imageSource, mapsUrl } = UseMapboxStaticImage({ space, mapbp });

    const getSchedule = (space: SpaceModel) => {
        if(space?.scheduleByAppointment || space?.scheduleByEventCalendar){
            if(space?.scheduleByAppointment && space?.scheduleByEventCalendar){
                return 'Abre segundo calendário de eventos ou por marcação.'
            }else if(space?.scheduleByAppointment){
                return 'Abre por marcação.';
            }else{
                return 'Abre segundo calendário de eventos.'
            }
        }else{
            return <InfoSchedule schedule={space.weekSchedule} />;
        }
    }

    const getChildren = useCallback(() => {
        return space && <div
            style={{
                // visibility: !open ? `hidden` : `visible`,
                display: !open ? 'none' : 'flex',
                opacity: !open ? "0" : "1",
                height: !open ? '0' : '100%'
            }}
            className="infobar-container">

            <CollapsibleContainer>
                <Collapsible notAvailable={!shouldShowBio || (!space.bio && (!space.imageUrls || space.imageUrls.length <= 0))} className="top" title="Bio" titleClasses="infobar-title">
                    {(space.imageUrls && space.imageUrls.length > 0) &&
                        <div className="infoimages-wrapper"><InfoImages wrap={true} space={space} /></div>}
                    <div className="infodesc-wrapper"><InfoDescription space={space} /></div>
                </Collapsible>

                <Collapsible title="Morada" titleClasses="infobar-title">
                    <InfoAddress space={space} open={space?.properties.open} imageSource={imageSource} mapsUrl={mapsUrl} />
                </Collapsible>

                <Collapsible notAvailable={shouldHideSchedule(space)} title="Horário" titleClasses="infobar-title">
                    {getSchedule(space)}
                </Collapsible>

                <Collapsible notAvailable={!hasContacts(space)} title="Contactos" titleClasses="infobar-title">
                    <InfoContacts space={space} />
                </Collapsible>

                <Collapsible notAvailable={!hasTech(space)} title="Ficha Técnica" titleClasses="infobar-space">
                    <InfoTech space={space} />
                </Collapsible>
            </CollapsibleContainer>
        </div >
    }, [imageSource, mapsUrl, open, space])

    return <div style={{ height: "100%" }}>
        {getChildren()}
    </div >

}